module.exports = __webpack_public_path__ + "fonts/Noto_Sans_TC-400-110.3b9432c.woff2";